const commonApi = process.env.VUE_APP_COMMON_API
const mesUrl = process.env.VUE_APP_MES_API

export default {
  ROWS: 20, //列表行数
  ROWS_20: 20, //列表行数
  DIALOG_ROWS: 10, //弹窗中列表行数

  UPLOAD_IMG_PATH: `${commonApi}aliYun/file/uploadImage`,
  UPLOAD_IMG_PUBLIC_PATH: `${commonApi}aliYun/file/uploadImagePublic`,
  DOWNLOAD_IMG_PATH: `${commonApi}aliYun/file/downloadImage`,

  UPLOAD_FILE_PATH: `${commonApi}aliYun/file/uploadFile`,
  UPLOAD_FILE_PUBLIC_PATH: `${commonApi}aliYun/file/uploadFilePublic`,
  DOWNLOAD_FILE_PATH: `${commonApi}aliYun/file/downloadFile`,
  DOWNLOAD_VIDEO_PATH: `${commonApi}aliYun/file/downloadVideo`,
  DOWNLOAD_ZIP_PATH: `${commonApi}aliYun/file/downloadZip`,

  MES_UPLOAD_IMG_PATH: mesUrl + 'file/uploadImage', //mes上传图片地址
  MES_UPLOAD_IMG_PUBLIC_PATH: mesUrl + 'file/uploadImagePublic', //mes上传图片地址（公有）
  MES_DOWNLOAD_IMG_PATH: mesUrl + 'file/downloadImage', //mes下载图片地址
  MES_UPLOAD_VIDEO_PATH: mesUrl + 'file/uploadVideo', //mes上传视频地址
  MES_DOWNLOAD_VIDEO_PATH: mesUrl + 'file/downloadVideo' //mes下载视频地址
}
